import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CONTACTS, MAILTO } from "../mock";

const Section = ({ n, title, children }) => (
  <section className="border-t border-[var(--cm-line)] pt-8">
    <p className="font-mono-cm text-[0.68rem] uppercase tracking-[0.12em] text-[#9a9a92]">
      <span className="text-[var(--cm-green)]">{n}</span> {title}
    </p>
    <div className="mt-4 space-y-3 text-[0.95rem] leading-relaxed text-[#4a4a45]">
      {children}
    </div>
  </section>
);

export default function Condizioni() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <Header />
      <main className="pb-24 pt-[100px] lg:pt-[120px]" data-testid="condizioni-page">
        <div className="mx-auto max-w-[860px] px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-[0.85rem] text-[#6f6f68] transition-colors hover:text-[var(--cm-ink)]"
          >
            <ArrowLeft size={15} /> Torna alla home
          </Link>

          <p className="label-mono mb-4 mt-8">Termini di servizio</p>
          <h1 className="h-display text-[clamp(1.9rem,4vw,3rem)]">
            Condizioni di vendita e prenotazione
          </h1>
          <p className="mt-4 text-[0.95rem] text-[#6f6f68]">
            Ultimo aggiornamento: giugno 2026. Le presenti condizioni regolano l'uso del
            sito www.carmaps.it e la prenotazione dei veicoli proposti da Carmaps.
          </p>

          <div className="mt-12 space-y-12">
            <Section n="01" title="Chi siamo">
              <p>
                Carmaps — Corso Francia 115, 10093 Collegno (TO). P. IVA {CONTACTS.piva} ·
                RUI {CONTACTS.rui}. Contatti: {CONTACTS.ufficio} ·{" "}
                <a href={MAILTO} className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
                  {CONTACTS.email}
                </a>. www.carmaps.it è l'unico sito ufficiale.
              </p>
            </Section>

            <Section n="02" title="Annunci e disponibilità">
              <p>
                Le schede dei veicoli riportano le informazioni raccolte da Carmaps durante il
                controllo della vettura. La disponibilità viene aggiornata manualmente: può
                accadere che un'auto risulti prenotata o venduta poco prima dell'aggiornamento.
                La prenotazione non costituisce accettazione definitiva finché non confermata
                da Carmaps.
              </p>
            </Section>

            <Section n="03" title="Richiesta di blocco e prenotazione">
              <ul className="list-disc space-y-1 pl-5">
                <li>Invii una richiesta di blocco del veicolo: la <strong>richiesta da sola non blocca ancora</strong> la vettura.</li>
                <li>Carmaps verifica disponibilità e condizioni e ti ricontatta.</li>
                <li>L'<strong>importo di prenotazione</strong> proposto è di <strong>300 €, interamente rimborsabile</strong>, e riserva il veicolo per <strong>sette giorni</strong>, salvo diverso accordo.</li>
                <li>Durante il periodo confermato, Carmaps sospende le altre trattative sul veicolo.</li>
                <li>Per procedere all'acquisto il cliente deve <strong>visionare di persona il veicolo</strong> presso la nostra sede o nel luogo concordato.</li>
                <li>In caso di acquisto, i 300 € vengono <strong>scalati dal prezzo</strong> del veicolo.</li>
                <li>In caso di rinuncia dopo la visione, <strong>Carmaps dispone il rimborso il giorno stesso della visione</strong>; i tempi di accredito seguono il metodo di pagamento utilizzato.</li>
              </ul>
              <p>
                L'importo di prenotazione viene gestito da Carmaps dopo la verifica di
                disponibilità. Il blocco del veicolo decorre dalla conferma da parte di Carmaps.
              </p>
            </Section>

            <Section n="04" title="Prezzi e finanziamento">
              <p>
                I prezzi indicati sono comprensivi come specificato in scheda. Il costo del
                passaggio di proprietà, quando indicato, è a parte. Le rate di finanziamento
                mostrate dal calcolatore sono <strong>stime indicative</strong> non vincolanti,
                soggette all'approvazione dell'istituto finanziario. Nessun contratto di
                finanziamento si conclude tramite il sito.
              </p>
            </Section>

            <Section n="05" title="Garanzia">
              <p>
                Ai veicoli venduti da Carmaps a consumatori si applica la garanzia legale di
                conformità prevista dal Codice del Consumo (D.lgs. 206/2005). Le condizioni di
                un'eventuale garanzia commerciale aggiuntiva vengono comunicate e concordate al
                momento dell'acquisto.
              </p>
            </Section>

            <Section n="06" title="Legge applicabile">
              <p>
                Le presenti condizioni sono regolate dalla legge italiana. Per i consumatori
                resta ferma la competenza del foro del luogo di residenza o domicilio.
              </p>
            </Section>
          </div>

          <p className="mt-14 text-[0.85rem] text-[#9a9a92]">
            Vedi anche la nostra{" "}
            <Link to="/privacy" className="underline underline-offset-2 hover:text-[var(--cm-ink)]">
              Privacy Policy
            </Link>.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
